function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
export default (function (_ref) {
  var colors = _ref.colors,
    mediaQueries = _ref.mediaQueries;
  return {
    container: _defineProperty({
      '& p, & a': {
        fontSize: '14px'
      }
    }, mediaQueries.breakpointLarge, {
      padding: '0'
    }),
    or: {
      color: colors.lightGrayDescription,
      padding: '20px 0 10px',
      display: 'block'
    }
  };
});